module.exports = __webpack_public_path__ + "static/img/why-6.11e19121.jpg";